export const API_SIGN_METHODS = {
  DECRYPT: "verify_data_internal",
};
